export default "__VITE_ASSET__a56087a6__"